"use client";

import * as React from "react";

import {
  Crown,
  Award,
  Star,
  Shield,
  Users,
} from 'lucide-react';

const getTierIcon = (tier: string) => {
  switch (tier) {
    case 'platinum': return Crown;
    case 'gold': return Award;
    case 'silver': return Star;
    case 'bronze': return Shield;
    case 'open': return Users;
    default: return Shield;
  }
};


const getTierColor = (tier) => {
  const tierColors = {
    'platinum': '#9B5AA5',
    'gold': '#F99928',
    'silver': '#005295',
    'bronze': '#EF3E34',
    'open': '#7AC142',
    'base': '#6B7280',
    'reseller': '#9B5AA5',
    'volume': '#005295',
    'internal': '#64748b'
  };
  return tierColors[tier];
};


export { getTierColor, getTierIcon };
